import React from 'react'
import clsx from 'clsx'

import { CustomLink } from '@/components/atoms/CustomLink/CustomLink'
import { Paragraph } from '@/components/atoms/MarkdownElements/MarkdownElements'
import { PageNotFoundTypes } from './types'
import * as styles from './PageNotFound.module.css'

export function PageNotFound({ title, description, background, helpful_links }: PageNotFoundTypes) {
  const additionalParams: { style?: React.CSSProperties } = {}

  if (background) {
    additionalParams.style = { backgroundImage: `url(${background.image})` }
  }

  return (
    <div className={clsx(background ? 'bg-center bg-no-repeat' : null, styles.backgroundImage)} {...additionalParams}>
      <section className="flex items-center flex-col max-w-screen-desktop mx-auto p-24 netbook:px-90 netbook:py-64">
        <h1 className={clsx(styles.title, 'text-headingL font-bold text-text-dark-900 font-poppins text-center mb-80')}>
          {title}
        </h1>
        {description && (
          <Paragraph className="text-bodyL text-text-dark-900 max-w-2xl text-center">{description}</Paragraph>
        )}

        {helpful_links &&
          helpful_links.map((link) => (
            <CustomLink
              key={link._uid}
              {...link}
              className="w-full mobile:w-1/3 netbook:w-320 mt-96 py-16 px-24 rounded bg-primary-500 transition duration-200 ease-in hover:bg-primary-900 text-white font-bold text-center"
            >
              {link.text}
            </CustomLink>
          ))}
      </section>
    </div>
  )
}
